import React, {useState} from "react";
import {Link} from "react-router-dom";
import enFlag from "../static/img/BritishFlag.png";
import ukrFlag from "../static/img/UkrainianFlag.png"
import "./Microcredit.style.scss";

const Survey: React.FC = ()=> {
    const [isHovered, setIsHovered] = useState({on: false, index: 0});
    const [en, setEn] = useState(false);
    const row1 = ["1. Management and planning of protected areas and their networks in post-war reconstruction ",
        "1. Biodiversity conservation and management of biological resources, including the management and planning of protected areas and their networks, including in war recovery context (for Ukraine), management of wild species, transboundary issues, policy tools and instruments",
        "3","Maksymenko N.","01.01.2026","https://forms.gle/qSMrfhCuF6BWC3G48"];
    const row2 = ["2. Biodiversity of urban landscapes",
        "4","Hrechko A., Maksymenko N.","01.01.2026","https://forms.gle/owdNiVtBnYewSXDK7"];
    const row3 = ["3. State Policy on the Use and Conservation of Soil and Forest Resources in the Wartime and Postwar Periods",
        "2. Pollution prevention, control and remediation, including air (indoor and outdoor), water and soil polution, transboundary issues and their policy and management, remediation of soil and water bodies, inclusing in war zones (for Ukraine)",
        "3","Koval I., Gololobova O.","01.01.2026","https://forms.gle/yW7V6vdW3dyVJAzTA"];
    const row4 = ["4. Biological methods for assessing the quality of environmental components",
        "3","Krainiukov O., Krivitska I.","01.09.2025","https://forms.gle/yiiWDcHggpCWwq9BA"];
    const row5 = ["5. EIA for customers, contractors and the public ",
        "3. Green planning and management tools and instruments, including adaptive and sustainable approaches, integration of NBS and ecosystem services, sustainable drainage systems, inclusive planning, war resilient planning and post-war recovery (for Ukraine)",
        "3","Titenko G.","01.09.2025","https://forms.gle/AEFUaRAWYvj6XXsL6"];
    const row6 = ["6. Management of environmental activities and environmental documentation enterprises  ",
        "2","Burchenko S., Maksymenko N.","01.09.2025","https://forms.gle/k4CdNfcDg4bhxXfr9"];
    const row7 = ["7. Financial instruments of \"green\" banking",
        "4. Financial and economic instruments for green development, including green investments, banking, procurement, tarifs, taxonomies, certification etc",
        "3","Kot A.","01.09.2025","https://forms.gle/sxs9NN5BQM1u3MKj9"];
    const row8 = ["8. Remote environmental monitoring",
        "5. Observation, information and communication for green development, including ICT, media, GIS, remote sensing, environmental monitoring and meteorological observations",
        "2","Klieshch A.","01.09.2025","https://forms.gle/TiH21QK58xzNM1JW8"];
    const row9 = ["9. Web technologies and information support in the field of conservation",
        "2","Klieshch A.","01.09.2025","https://forms.gle/emdEpfhLpBrueMof7"];
    const row10 = ["10. Integrated water resources assessment and management: strategy, methods and tools",
        "6. Improve water use and protection, To improve and control water use, regulate and manage the effects of natural and human activities affecting surface and underground water use.",
        "3","Nekos A., Bezsonnyi V.","01.09.2025","https://forms.gle/AonARUJMVvKFpuvJ6"];
    const row1Ua = ["1. Управління та планування природоохоронних територій та їх мереж в умовах післявоєнної відбудови",
        "1. Збереження біорізноманіття та управління біологічними ресурсами, включаючи управління та планування природоохоронних територій та їх мереж, у тому числі в контексті відновлення після війни (для України), управління дикими видами, транскордонні питання, політичні засоби та інструменти",
        "3","Максименко Н.","01.01.2026","https://forms.gle/qSMrfhCuF6BWC3G48"];
    const row2Ua = ["2. Біорізноманіття урболандшафтів ","4","Гречко А, Максименко Н.","01.01.2026","https://forms.gle/owdNiVtBnYewSXDK7"];
    const row3Ua = ["3. Державна політика у сфері використання та охорони земельних і лісових ресурсів у воєнний та повоєнний періоди",
        "2. Запобігання, контроль та відновлення забруднення, включаючи забруднення повітря (внутрішнього та зовнішнього), води та ґрунту, транскордонні питання, політика та управління ними, відновлення ґрунту та водних об'єктів, у тому числі в зонах бойових дій (для України)",
        "3","Коваль І., Гололобова О.","01.01.2026","https://forms.gle/yW7V6vdW3dyVJAzTA"];
    const row4Ua = ["4. Біологічні методи оцінки якості компонентів навколишнього середовища","3","Крайнюков О., Кривицька І.","01.09.2025","https://forms.gle/yiiWDcHggpCWwq9BA"];
    const row5Ua = ["5. ОВД для замовників, підрядників та громадськості",
        "3. Інструменти та засоби зеленого планування та управління, включаючи адаптивні та сталі підходи, інтеграцію НСБ та екосистемних послуг, стійкі дренажні системи, інклюзивне планування, планування, стійке до війни та післявоєнне відновлення (для України)",
        "3","Тітенко Г.","01.09.2025","https://forms.gle/AEFUaRAWYvj6XXsL6"];
    const row6Ua = ["6. Управління природоохоронною діяльністю та екологічною документацією підприємств","2","Бурченко С., Максименко Н.","01.09.2025","https://forms.gle/k4CdNfcDg4bhxXfr9"];
    const row7Ua = ["7. Фінансові інструменти \"зеленого\" банкінгу",
        "4. Фінансові та економічні інструменти для зеленого розвитку, включаючи зелені інвестиції, банківську діяльність, закупівлі, тарифи, таксономії, сертифікацію тощо",
        "3","Кот А.","01.09.2025","https://forms.gle/sxs9NN5BQM1u3MKj9"];
    const row8Ua = ["8 . Дистанційний моніторинг навколишнього середовища",
        "5. Спостереження, інформація та комунікація для зеленого розвитку, включаючи ІКТ, медіа, ГІС, дистанційне зондування, моніторинг навколишнього середовища та метеорологічні спостереження",
        "2","Клєщ А.","01.09.2025","https://forms.gle/TiH21QK58xzNM1JW8"];
    const row9Ua = ["9. Веб-технології та інформаційна підтримка у сфері охорони природи","2","Клєщ А.","01.09.2025","https://forms.gle/emdEpfhLpBrueMof7"];
    const row10Ua = ["10. Інтегрована оцінка та управління водними ресурсами: стратегія, методи та інструменти",
        "6. Покращити використання та охорону водних ресурсів, Покращити та контролювати використання водних ресурсів, регулювати та управляти наслідками природної та антропогенної діяльності, що впливають на використання поверхневих та підземних вод.",
        "3","Некос А., Безсонний В.","01.09.2025","https://forms.gle/AonARUJMVvKFpuvJ6"];

    return (
        <div style={{margin:"30px auto 20px auto"}}>
            <div style={{display:"flex",flexDirection:"row",justifyContent:"space-evenly",marginBottom:"50px"}} >
                <Link to={"/"} className={"consortium_link"}
                      style={(isHovered.on && isHovered.index === 0) ? {color:"gray",boxShadow:"3px 3px 3px"} : {color:"white"}}
                      onMouseEnter={() => setIsHovered({on:true,index:0})}
                      onMouseLeave={() => setIsHovered({on:false,index:0})}
                >&#8592; Back</Link>
                <button className={"consortium_button"}
                        onClick={()=> setEn(!en)} >
                    {en ? <img src={ukrFlag} alt="flag"/> : <img src={enFlag} alt="flag"/>}
                </button>
            </div>

            <div style={{display:"flex",justifyContent:"center"}}>
                <h3 style={{maxWidth:"68%"}} >
                    {en ? "Dear friends, the DOMANI project is developing and will be teaching microcredit programs on environmental issues." +
                        " If you are interested in gaining new knowledge, we invite you to take the survey:" :
                        "Шановні друзі, в проєкті DOMANI розробляються і будуть викладатись мікрокредитні програми з екологічної проблематики." +
                        " Якщо Ви зацікавлені в отриманні нових знань - запрошуємо пройти опитування:"}
                </h3>
            </div>

            <table>
                <thead>
                <tr>
                    {en ? <th className={"head"}>Named</th> : <th className={"head"}>Назва</th>}
                    {en ? <th className={"head"}>Straight</th> : <th className={"head"}>Напрям</th>}
                    {en ? <th className={"head"}>Credits</th> : <th className={"head"}>Кредити</th>}
                    {en ? <th className={"head"}>Lecturer</th> : <th className={"head"}>ПІБ</th>}
                    {en ? <th className={"head"}>Dedline</th> : <th className={"head"}>Dedline</th>}
                    {en ? <th className={"head"}>Google form</th> : <th className={"head"}>Google форма</th>}
                </tr>
                </thead>
                <tbody id="table-body">
                {en ? <tr>
                    {row1.map((el, index) => (
                        <td key={index} rowSpan={(index === 1) ? 2 : 1}
                            className={`col${index}`}
                        >{(index === 5) ? <a href={el} >{el}</a> : el }</td>
                    ))}
                </tr> : <tr>
                    {row1Ua.map((el, index) => (
                        <td key={index} rowSpan={(index === 1) ? 2 : 1}
                            className={`col${index}`}
                        >{(index === 5) ? <a href={el} >{el}</a> : el }</td>
                    ))}
                </tr>}
                {en ? <tr>
                    {row2.map((el, index) => (
                        <td key={index}
                            className={`col${index}`}
                        >{(index === 4) ? <a href={el} >{el}</a> : el }</td>
                    ))}
                </tr> : <tr>
                    {row2Ua.map((el, index) => (
                        <td key={index}
                            className={`col${index}`}
                        >{(index === 4) ? <a href={el} >{el}</a> : el }</td>
                    ))}
                </tr>}
                {en ? <tr>
                    {row3.map((el, index) => (
                        <td key={index} rowSpan={(index === 1) ? 2 : 1}
                            className={`col${index}`}
                        >{(index === 5) ? <a href={el} >{el}</a> : el }</td>
                    ))}
                </tr> : <tr>
                    {row3Ua.map((el, index) => (
                        <td key={index} rowSpan={(index === 1) ? 2 : 1}
                            className={`col${index}`}
                        >{(index === 5) ? <a href={el} >{el}</a> : el }</td>
                    ))}
                </tr>}
                {en ? <tr>
                    {row4.map((el, index) => (
                        <td key={index}
                            className={`col${index}`}
                        >{(index === 4) ? <a href={el} >{el}</a> : el }</td>
                    ))}
                </tr> : <tr>
                    {row4Ua.map((el, index) => (
                        <td key={index}
                            className={`col${index}`}
                        >{(index === 4) ? <a href={el} >{el}</a> : el }</td>
                    ))}
                </tr>}
                {en ? <tr>
                    {row5.map((el, index) => (
                        <td key={index} rowSpan={(index === 1) ? 2 : 1}
                            className={`col${index}`}
                        >{(index === 5) ? <a href={el} >{el}</a> : el }</td>
                    ))}
                </tr> : <tr>
                    {row5Ua.map((el, index) => (
                        <td key={index} rowSpan={(index === 1) ? 2 : 1}
                            className={`col${index}`}
                        >{(index === 5) ? <a href={el} >{el}</a> : el }</td>
                    ))}
                </tr>}
                {en ? <tr>
                    {row6.map((el, index) => (
                        <td key={index}
                            className={`col${index}`}
                        >{(index === 4) ? <a href={el} >{el}</a> : el }</td>
                    ))}
                </tr> : <tr>
                    {row6Ua.map((el, index) => (
                        <td key={index}
                            className={`col${index}`}
                        >{(index === 4) ? <a href={el} >{el}</a> : el }</td>
                    ))}
                </tr>}
                {en ? <tr>
                    {row7.map((el, index) => (
                        <td key={index}
                            className={`col${index}`}
                        >{(index === 5) ? <a href={el} >{el}</a> : el }</td>
                    ))}
                </tr> : <tr>
                    {row7Ua.map((el, index) => (
                        <td key={index}
                            className={`col${index}`}
                        >{(index === 5) ? <a href={el} >{el}</a> : el }</td>
                    ))}
                </tr>}
                {en ? <tr>
                    {row8.map((el, index) => (
                        <td key={index} rowSpan={(index === 1) ? 2 : 1}
                            className={`col${index}`}
                        >{(index === 5) ? <a href={el} >{el}</a> : el }</td>
                    ))}
                </tr> : <tr>
                    {row8Ua.map((el, index) => (
                        <td key={index} rowSpan={(index === 1) ? 2 : 1}
                            className={`col${index}`}
                        >{(index === 5) ? <a href={el} >{el}</a> : el }</td>
                    ))}
                </tr>}
                {en ? <tr>
                    {row9.map((el, index) => (
                        <td key={index}
                            className={`col${index}`}
                        >{(index === 4) ? <a href={el} >{el}</a> : el }</td>
                    ))}
                </tr> : <tr>
                    {row9Ua.map((el, index) => (
                        <td key={index}
                            className={`col${index}`}
                        >{(index === 4) ? <a href={el} >{el}</a> : el }</td>
                    ))}
                </tr>}
                {en ? <tr>
                    {row10.map((el, index) => (
                        <td key={index}
                            className={`col${index}`}
                        >{(index === 5) ? <a href={el} >{el}</a> : el }</td>
                    ))}
                </tr> : <tr>
                    {row10Ua.map((el, index) => (
                        <td key={index}
                            className={`col${index}`}
                        >{(index === 5) ? <a href={el} >{el}</a> : el }</td>
                    ))}
                </tr>}
                </tbody>
            </table>
        </div>
    )
}
export default Survey;